import { ReactNode } from 'react';
import styled from 'styled-components';
// fixed in major version bump but upgrade introduces esm/import issues
/* @ts-ignore see https://github.com/nolimits4web/swiper/pull/6626 */
import { Navigation, Keyboard, A11y } from 'swiper';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react';

/* eslint-disable-next-line import/no-unresolved */
import 'swiper/css';
import CarouselButtonImg from '../images/homepage-refresh/red-circle-arrow.svg';

const Wrapper = styled.div`
  .swiper-slide {
    height: auto;
  }

  .swiper {
    padding-bottom: 60px;
  }

  .swiper-button-prev,
  .swiper-button-next {
    position: absolute;
    top: auto;
    bottom: 0;
    height: 40px;
    width: 40px;
    transform: translateY(0);
    background-image: url(${CarouselButtonImg});
    background-size: contain;
    background-repeat: no-repeat;
    cursor: pointer;
  }

  .swiper-button-prev {
    left: calc(50% - 60px);
    transform: rotate(180deg);
  }

  .swiper-button-next {
    right: calc(50% - 60px);
  }

  .swiper-button-disabled {
    display: none;
  }
`;

interface CarouselProps extends SwiperProps {
  items: ReactNode[];
}

export default function Carousel({ items, ...swiperProps }: Readonly<CarouselProps>) {
  if (items.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <Swiper
        allowTouchMove
        centerInsufficientSlides
        keyboard
        navigation
        modules={[A11y, Keyboard, Navigation]}
        spaceBetween={30}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          // md
          678: {
            slidesPerView: 2,
          },
          // lg
          960: {
            slidesPerView: 3,
          },
        }}
        {...swiperProps}
      >
        {items.map((Item, i) => {
          const key = `slide-${i}`;
          return (
            <SwiperSlide key={key}>
              {Item}
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Wrapper>
  );
}
